import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Switch, TextField } from "@mui/material";
import MainContainer from "../../layout/MainContainer";
import { ENUM_ROUTES } from "../../RoutesEnum";
import { useLazyGetPointsDetailQuery, useUpdatePointsMutation } from "../../services/loyaltyPoint";
import { showError, showToast } from "../../constants/toasts";

const EditLoyaltyPoints = () => {
  const navigate = useNavigate();
  const { id } = useParams()
  const [programEnabled, setProgramEnabled] = useState<boolean>(false);
  const [pricePerPoint, setPricePerPoint] = useState<string>("");
  const [redeemLimitPerBooking, setRedeemLimitPerBooking] = useState<string>("");
  const [minPurchaseToRedeem, setMinPurchaseToRedeem] = useState<string>("");
  const [updatePoitns] = useUpdatePointsMutation()
  const [getById] = useLazyGetPointsDetailQuery()
  const [data, setData] = useState<any | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const getDataByIdList = async () => {
    try {
      setLoading(true);
      if (!id) return;
      const response = await getById({ id }).unwrap();
      if (response.statusCode === 200) {
        setData(response.data);
      }
    } catch (error: any) {
      showError(error?.message || error?.data?.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (data) {
      setProgramEnabled(Boolean(data.status));
      setPricePerPoint(typeof data.value === "number" ? String(data.value) : data.value ?? "");
      setRedeemLimitPerBooking(
        typeof data.pointPerOrder === "number" ? String(data.pointPerOrder) : data.pointPerOrder ?? ""
      );
      setMinPurchaseToRedeem(
        typeof data.minimumPurchase === "number" ? String(data.minimumPurchase) : data.minimumPurchase ?? ""
      );
    }
  }, [data]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!id) return;
    try {
      setLoading(true);
      const body = {
        status: programEnabled,
        value: Number(pricePerPoint || 0),
        pointPerOrder: Number(redeemLimitPerBooking || 0),
        minimumPurchase: Number(minPurchaseToRedeem || 0),
      };
      const res = await updatePoitns({ id, body }).unwrap();
      if (res?.statusCode === 200) {
        showToast("Loyalty points updated successfully");
        navigate(ENUM_ROUTES.MANAGE_LOYALTY_POINTS);
      }
    } catch (error: any) {
      showError(error?.message || error?.data?.message);
    }
    setLoading(false);
  };
  useEffect(() => {
    if (id) {
      getDataByIdList()
    }
  }, [])
  return (
    <MainContainer>
      <div className="main_title">
        <h1>Edit Loyalty Program Setting</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
          <span onClick={() => navigate(ENUM_ROUTES.MANAGE_LOYALTY_POINTS)}> Loyalty Points</span>
          {" "}- Edit
        </p>
      </div>

      <div className="cards">
        <form className="form" onSubmit={handleSubmit}>
          <div className="gap_p">
            <div className="control_group w_100">
              <label>Loyal Program</label>
              <div className="switch_inline">
                <Switch checked={programEnabled} onChange={(e) => setProgramEnabled(e.target.checked)} />
              </div>
            </div>

            <div className="control_group w_50">
              <label>Define Price Per Loyalty Point*</label>
              <TextField
                className="text_field"
                fullWidth
                placeholder="Point value"
                value={pricePerPoint}
                onChange={(e) => setPricePerPoint(e.target.value)}
                inputProps={{ inputMode: "decimal" }}
                disabled={loading}
              />
            </div>

            <div className="control_group w_50">
              <label>Redemption Limit (point per booking)*</label>
              <TextField
                className="text_field"
                fullWidth
                placeholder="Enter limit"
                value={redeemLimitPerBooking}
                onChange={(e) => setRedeemLimitPerBooking(e.target.value)}
                inputProps={{ inputMode: "numeric" }}
                disabled={loading}
              />
            </div>

            <div className="control_group w_50">
              <label>Minimum Purchase to Redeem Points</label>
              <TextField
                className="text_field"
                fullWidth
                placeholder="Enter amount"
                value={minPurchaseToRedeem}
                onChange={(e) => setMinPurchaseToRedeem(e.target.value)}
                inputProps={{ inputMode: "decimal" }}
                disabled={loading}
              />
            </div>
          </div>

          <div className="form_btn">
            <Button className="btn btn_primary" type="submit" disabled={loading}>Save Setting</Button>
          </div>
        </form>
      </div>
    </MainContainer>
  );
};

export default EditLoyaltyPoints;


